module.exports = __webpack_public_path__ + "img/item4-5m.cd27e903.jpg";